// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__m74rZ","logo":"Footer_logo__pPVVT","layer":"Footer_layer__9YFGz","alignRight":"Footer_alignRight__Fau+h","webbing":"Footer_webbing__HH0qR"};